/* eslint-disable no-prototype-builtins */
'use strict';

/* eslint-disable no-undef */
/* eslint-disable one-var */
/** IE9, IE10 and IE11 requires all of the following browser polyfills. * */
module.exports.init = function () {
    // Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
    (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('append')) {
                return;
            }
            Object.defineProperty(item, 'append', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function append() {
                    var argArr = Array.prototype.slice.call(arguments),
                        docFrag = document.createDocumentFragment();
                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node;
                        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                    });
                    this.appendChild(docFrag);
                }
            });
        });
    }([Element.prototype, Document.prototype, DocumentFragment.prototype]));
};
